import DiamondCardModalWrapper from "./DiamondCardModalWrapper";

export default DiamondCardModalWrapper;
